import React, { useEffect, useState } from "react";
import style from "./Toast.module.scss";


const Toast = (props) => {

    const [toastShow, setToastShow] = useState('')

    const toggle = () => {
        let childData = {
            label: props.tag,
        }
        if (toastShow) {
            setToastShow(false);
            childData.value = false;
        } else {
            setToastShow(true);
            childData.value = false;
        }
        props.parentClose(childData)
    }

    useEffect(() => {
        // console.log(props.value,"pppp");
        if (props.value) {
            setToastShow(true);
        } else {
            setToastShow(false);
        }
        // console.log(toastShow);
    }, [props.value]);

    return (
        <div className={style.ToastFrame}>
            <div className={toastShow ? style.alert : style.hideAlert} id="toast">
                <div className={style.exclaminationIcon}>f</div>
                <div className={style.errorTextWrapper}>
                    {props.children}
                </div>
            </div>
        </div>
    );
}

export default Toast;
/*
   tag ======> name of toast
   value=true =======> showToast
   value=false  =======> hideToast
   text='' ==========> Toast text(REQUIRED)
   parentClose =====> set showToast to false

   !!!**** very important toast need to have a div as container with height: 0px; to get Coordinates where to appeare and zero manipulation ; ****!!!
*/